import {IPlayerMessagesService} from "./player-messages.service.interface";
import {ServiceBase} from "../ServiceBase";

export class PlayerMessagesService extends ServiceBase implements IPlayerMessagesService {
    waitForPlayerMessagesReady(): Promise<void> {
        if(this.services.sdk.isPlayerMessagesConnected) {
            return Promise.resolve();
        }

        return new Promise<void>(resolve => {
           this.services.sdk.events.onPlayerMessagesConnected(() => {
               resolve();
           })
        });
    }

}